module.exports = __webpack_public_path__ + "static/media/20.495e330e.webp";